





























import {Component, Vue} from 'vue-property-decorator';
import * as microtime from '@/lib/microtime';

@Component
export default class StringToNumberConverter extends Vue {
    input: string = microtime.toISOString(microtime.now());
    output: number = 0;
    errors: string[] = [];

    onFormSubmit() {
        this.output = 0;
        this.errors = [];
        if (!microtime.isISOString(this.input)) {
            this.errors.push('Input not supported.');
            return;
        }

        this.output = microtime.parseISOString(this.input);
    }

    get inputValid() {
        return microtime.isISOString(this.input);
    }
}
